import {TreeNode} from "../types/types";
import React from "react";
import {Breadcrumb} from "antd";
import "./componentsCSS/Dashboard.css";

interface SelectedItemPathProps {
    selectedNode: TreeNode;
    handleSelect: (newValue: string) => void;
}

const SelectedItemPath: React.FC<SelectedItemPathProps> = ({selectedNode, handleSelect}) => {
    const breadcrumbItems = selectedNode.path.map((item, index) => ({
        title: index === selectedNode.path.length - 1 ? (
            <span>{item}</span>
        ) : (
            <span
                style={{cursor: "pointer", color: "#1890ff"}}
                onClick={() => handleSelect(item)}
            >
            {item}
        </span>
        ),
    }));


    return (
        <div>
            {selectedNode?.path.length > 1 && (
                <div className="selected-title">
                    <Breadcrumb separator=">" items={breadcrumbItems}/>
                </div>
            )
            }
        </div>

    )
}

export default SelectedItemPath;